import React, { useEffect, useState, useContext } from "react";
import { useNavigate } from "react-router-dom";
import { AppContext } from "../../../contexts/AppContext";
import MenuButton from "../../../components/MenuButton/MenuButton";
import GeneralButton from "../../../components/GeneralButton/GeneralButton";
import "../../../styles/globals.css";
import "./FamilyListPage.css";
import { getFamilyInfo } from "../../../services/service";
import { showToast } from "../../../utils/commonUtils";

/**
 * 家族一覧画面用のコンポーネント
 * @param {} なし
 * @return {}  なし
 */
function FamilyListPage() {
  const {
    globalFamilyInfo,
    setGlobalSelectPatient,
    globalAccessToken,
    globalLoginUserInfo,
    setGlobalFamilyInfo,
  } = useContext(AppContext);
  const [dispPatients, setDispPatients] = useState(null);
  const [familyInfo, setFamilyInfo] = useState(null);
  const navigate = useNavigate();

  /**
   * コンポーネントがマウントされた時
   */
  useEffect(() => {
    //家族情報を取得
    const loadDatas = async () => {
      try {
        const familyInfo = await getFamilyInfo(
          globalLoginUserInfo.userInfo.adb2cId,
          globalAccessToken
        );
        if (familyInfo.result.status === "OK") {
          setFamilyInfo(familyInfo?.data.familyInfo);
          setGlobalFamilyInfo(familyInfo?.data.familyInfo);
        } else {
          // エラーメッセージセット
          showToast(familyInfo.result.error_message);
        }
      } catch (error) {
        console.error("Error getFamilyInfo:", error);
        showToast("家族情報取得に失敗しました", "error");
      }
    };

    if (!globalFamilyInfo) {
      loadDatas();
    } else {
      setFamilyInfo(globalFamilyInfo);
    }
  }, []);

  useEffect(() => {
    const familyMembers = [];
    familyInfo?.forEach((family) => {
      let familyMember = JSON.parse(JSON.stringify(family));
      familyMember.familyMemberId = family?.patientId;
      familyMember.kanjiLast = family?.kanjiLast;
      familyMember.kanjiFirst = family?.kanjiFirst;
      familyMember.kanaLast = family?.kanaLast;
      familyMember.kanaFirst = family?.kanaFirst;
      familyMember.birthday = family?.birthday;
      familyMember.sex = family?.sex;
      familyMembers.push(familyMember);
    });
    setDispPatients(familyMembers);
  }, [familyInfo]);

  /**
   * 家族追加ボタン押下時の処理
   * @param {} なし
   * @return {} なし
   */
  const handleAddClick = () => {
    // 保持
    setGlobalSelectPatient(null);

    // 家族情報登録画面に遷移
    navigate("/mypage/family-setting");
  };

  /**
   * 戻るボタン押下時の処理
   * @param {} なし
   * @return {} なし
   */
  const handleBackClick = () => {
    navigate("/mypage/menu");
  };

  /**
   * メニューボタンクリック時
   * @param {string} patientInfo - 選択受診者情報
   * @return {}  なし
   */
  const handleMenuClick = (patientInfo) => {
    // 保持
    setGlobalSelectPatient(patientInfo);

    // 家族情報登録画面に遷移
    navigate("/mypage/family-setting");
  };

  return (
    <div className="family-list">
      <div className="main-area">
        <div className="title">家族設定</div>
        <div className="detail"></div>
        {dispPatients && dispPatients.length > 0 && (
          <div className="menu-buttons">
            {dispPatients.map((menu, index) => (
              <MenuButton
                key={index}
                className="menu-button"
                isPerson
                buttonLabel={`${menu.kanjiLast} ${menu.kanjiFirst}`}
                onClick={() => handleMenuClick(menu)}
              />
            ))}
          </div>
        )}
        <div className="general-buttons">
          <GeneralButton
            buttonLabel={"家族追加"}
            type={
              dispPatients && dispPatients.length >= 6
                ? "disabled"
                : "secondary-blue"
            }
            onClick={handleAddClick}
          />
          <GeneralButton
            buttonLabel={"マイページに戻る"}
            type={"secondary-white"}
            onClick={handleBackClick}
          />
        </div>
      </div>
    </div>
  );
}

export default FamilyListPage;
